import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { UpdateTagParams } from '../Context';
import { useInvalidateProjectTagsQuery } from './useInvalidateTagsQuery';

export const useUpdateProjectTagMutation = (projectId: number) => {
  const apiClient = useChatApiClient();
  const invalidateTagsQuery = useInvalidateProjectTagsQuery(projectId);

  return useMutation({
    mutationFn: ({ tagId, ...updates }: UpdateTagParams) => {
      return apiClient.projects.updateProjectTag({
        projectId,
        tagId,
        updates,
      });
    },
    onSuccess: (res, params) => {
      invalidateTagsQuery();
    },
    onError: (error) => {
      console.error('Error updating project tag:', error);
    },
  });
};
